import { IconScale } from '@tabler/icons-react';
import { useStore } from '@/store';
import { translate } from '@/lib';
import style from './Style.module.scss';
import { notifications } from '@mantine/notifications';
import { useEffect } from 'react';

export function FloatingCompareButton() {
  const { compareList, setCompareModalOpen } = useStore();


  // Show hint alert when exactly 1 item in compare list
  useEffect(() => {
    if (compareList.length === 1) {
      notifications.show({
        message: translate('ff.action.compareHint', 'Please add 1 more gun to compare'),
      })
    }
  }, [compareList.length]);

  // Nothing to show when compare list is empty
  if (compareList.length === 0) {
    return null;
  }

  const handleClick = () => {
    setCompareModalOpen(true);
  };


  // Show compare button when 2+ items
  return (
    <div className={style.floatingWrapper}>
      <button
        className={`${style.floatingButton} ${style.hasItems}`}
        onClick={handleClick}
        aria-label="Compare guns"
      >
        <IconScale size={28} className={style.icon} />
        <span className={style.badge}>{compareList.length}</span>
      </button>
    </div>
  );
}
